export const YesNo = {
  false: 'Nē',
  true: 'Jā',
};

export const Gender = {
  false: 'Sieviete',
  true: 'Vīrietis',
};

export const CouponStatus = {
  Active: 'Aktīvs',
  Inactive: 'Neaktīvs',
  Delete: 'Dzēsts',
  Disabled: 'Atspējots',
  Issue: 'Izsniegts',
};

export const CouponCampaignPictogram = {
  0: 'Krūze',
  1: 'Dāvana',
  Cup: 0,
  Gift: 1,
};

export const CouponCampaignStatus = {
  0: 'Uzmetums',
  1: 'Gaida',
  2: 'Procesā',
  3: 'Apturēts',
  4: 'Pabeigts',
  5: 'Kļūdains',
  New: 0,
  Waiting: 1,
  Started: 2,
  Stopped: 3,
  Completed: 4,
  Error: 5,
};

export const ConvertToOptions = enumType => Object.keys(enumType)
  .filter(key => !Number.isNaN(Number(key)) || key === 'true' || key === 'false')
  .map((key) => {
    let value = key;
    if (!Number.isNaN(key)) {
      value = parseInt(key, 10);
    }
    if (key === 'true') value = true;
    if (key === 'false') value = false;
    return { value, label: enumType[key] };
  });

export const GetDays = () => {
  const days = [];

  for (let i = 1; i <= 31; i += 1) {
    days.push({ value: i, label: i });
  }

  return days;
};

export const GetMonths = () => {
  const months = [];

  for (let i = 1; i <= 12; i += 1) {
    months.push({ value: i, label: i });
  }

  return months;
};

export const GetYears = () => {
  const years = [];

  for (let i = 1920; i <= new Date().getFullYear(); i += 1) {
    years.push({ value: i, label: i });
  }

  return years;
};



// WEBPACK FOOTER //
// ./src/utils/enum.js